import axios from 'axios';
console.log(process.env.REACT_APP_API_URL)
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}api/v1` || 'http:localhost:3000/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'platform': 'admin'
  },
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('data'))?.auth_token || '';
    if (token) {
      config.headers['Authorization'] = token;
      config.platform = 'admin'
    }
    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const  d = error?.response?.data;
    if (error.response && error.response.status === 401 ||  d?.code === "UNAUTHORIZED" ||
        d?.message === "Unauthorized"
       ) {
       localStorage.clear();
       sessionStorage.clear();
       window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
